/*
 * @FilePath     : /es-template/src/store/modules/company/index.js
 * @Author       : LiYang
 * @Date         : 2021-08-26 16:32:00
 * @LastEditTime : 2022-01-04 16:15:53
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
import { createStore, mpx } from '@didi/es-mpx-creator'

const company = createStore({
  state: {
    info: mpx.getStorageSync('companyInfo') || {},
  },

  mutations: {
    init(state, payload) {
      state.info = payload;
    }
  },

  actions: {
    assign(context, payload) {
      context.commit('init', payload)
    }
  },
})

company.subscribe(function({type, payload}, state) {
  mpx.setStorageSync('companyInfo', Array.isArray(payload) ? payload[0] : payload)
})

export default company;